var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNorfolkIsland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9559 1.5886C20.8524 0.571477 18.4926 0.000976562 15.9994 0.000976562C13.5062 0.000976562 11.1464 0.571477 9.04292 1.5886L7.65161 16.001L9.04292 30.4134C11.1464 31.4305 13.5062 32.001 15.9994 32.001C18.4926 32.001 20.8524 31.4305 22.9559 30.4134L24.3472 16.001L22.9559 1.5886Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 1.58929C3.69156 4.17717 0 9.65773 0 16.0011C0 22.3445 3.69156 27.825 9.0435 30.4129V1.58929Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9558 1.58929V30.4129C28.3077 27.825 31.9993 22.3444 31.9993 16.0011C31.9993 9.65779 28.3077 4.17717 22.9558 1.58929Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1741 20.8708L16.0001 7.65338L11.8262 20.8708H14.9566V24.349H17.0436V20.8708H20.1741Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorfolkIsland);
export default __webpack_public_path__ + "static/media/norfolk-island.faffa6a6.svg";
export { ForwardRef as ReactComponent };